enum TransactionsOrderOptions {
    DisplayDate = "displayDate",
    Timestamp = "timestamp"
}
export default TransactionsOrderOptions;